export const TYPES = {
  FilesApiService: Symbol.for('FilesApiService'),
  FileUploadRepository: Symbol.for('FileUploadRepository'),
  FileUploadErrorHandlingRepository: Symbol.for('FileUploadErrorHandlingRepository'),
  FilesDao: Symbol.for('FilesDao'),
  FilesUseCases: Symbol.for('FilesUseCases'),
  FileInteractionRepository: Symbol.for('FileInteractionRepository'),
};
